import Icon from '../components/Icon.vue'

Icon.register({"user-times":{"width":640,"height":512,"paths":[{"d":"M224 32C301.3 32 364 94.7 364 172S301.3 312 224 312 84 249.3 84 172 146.7 32 224 32zM384.4 324.1L322 308.5C256.4 355.6 177 345.1 126 308.5L63.6 324.1C26.2 333.4 0 367 0 405.6V438C0 461.2 18.8 480 42 480H406C429.2 480 448 461.2 448 438V405.6C448 367 421.8 333.4 384.4 324.1zM587.9 256L636.5 207.4C641.2 202.7 641.2 195.1 636.5 190.5L609.5 163.5C604.9 158.8 597.3 158.8 592.6 163.5L544 212.1 495.4 163.5C490.7 158.8 483.1 158.8 478.5 163.5L451.5 190.5C446.8 195.1 446.8 202.7 451.5 207.4L500.1 256 451.5 304.6C446.8 309.3 446.8 316.9 451.5 321.5L478.5 348.5C483.1 353.2 490.7 353.2 495.4 348.5L544 299.9 592.6 348.5C597.3 353.2 604.9 353.2 609.5 348.5L636.5 321.5C641.2 316.9 641.2 309.3 636.5 304.6L587.9 256z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/user-times.js
// module id = null
// module chunks = 